import { Routes, Route, Navigate } from 'react-router-dom';
import Tools from '../../Tools/Tools';
import Layout from './Layout';
import Login from '../Login';
import Logout from '../Logout';
import Dashboard from '../Dashboard';
import KnowledgeList from '../knowledge/KnowledgeList';
import KnowledgeInfo from '../knowledge/KnowledgeInfo';
import Agents from '../agent/Agents';
import AgentDetail from '../agent/AgentDetail';
import Signup from '../account/Signup';
import SignupForm from '../account/SignupForm';  // Signup Form
import AccountSettings from '../account/AccountSettings';
import InstructionsList from '../instructions/InstructionsList';
import InstructionsInfo from '../instructions/InstructionsInfo';
import TenantDashboard from '../dashboard/TenantDashboard';
import UsageDashboard from '../dashboard/UsageDashboard';
import ChatMain from '../chat/ChatMain';
import ChatbotFramePage from '../../pages/public/ChatbotFramePage';
import SystemAlerts from '../SystemAlerts';
import FormsList from '../forms/FormsList';
import FormInfo from '../forms/FormInfo';
import AgentCreation from '../setup/AgentCreation';
import InviteSetup from '../account/InviteSetup';
import CompletePayment from '../account/CompletePayment';
import Analytics from '../account/analytics/Analytics';
import ChatLogs from '../logs/ChatLogs';
import HomeAnalytics from '../HomeAnalytics';
import QA from '../qa/QA';
import LiveChat from '../LiveChat';
import React, { useEffect } from 'react'; // added import
import { useLocation } from 'react-router-dom';

function RedirectToDashboard() {
  useEffect(() => {
    const { origin, pathname, search } = window.location;
    const target = `${origin}${pathname}${search}#/Dashboard`;
    window.location.replace(target);
  }, []);
  return null;
}

export default function AppRoutes({ loggedIn, setLoggedIn, user }) {
  const location = useLocation();
  // Determine whether a `next` param is present either in the search or inside the hash
  const searchParams = new URLSearchParams(location.search || '');
  const hasNextQuery = !!searchParams.get('next');
  let hasNextInHash = false;
  try {
    const hash = window.location.hash || '';
    const hashQuery = hash.split('?')[1] || '';
    const hashParams = new URLSearchParams(hashQuery || '');
    hasNextInHash = !!hashParams.get('next');
  } catch (e) {
    hasNextInHash = false;
  }
  const hasNext = hasNextQuery || hasNextInHash;
  return (
    <Routes>
      {/* All other routes inside Layout */}
      <Route path="/public/chatbot-frame" element={<ChatbotFramePage />} />
      <Route path="/invite" element={<InviteSetup />} />
      <Route path="/invite2" element={<Signup />} />
      <Route path="/" element={<Layout loggedIn={loggedIn} setLoggedIn={setLoggedIn} />}>
        {/* Redirect plain "#/" to "#/Dashboard" */}
        <Route index element={<Navigate to="/Dashboard" replace />} />
        {/* If already logged in, do not redirect to Dashboard immediately when a `next` param exists.
          This lets the Login component complete any hard/hash redirect (window.location.href)
          before other route guards replace the location. */}
        <Route path="/Login" element={loggedIn && !hasNext ? <Navigate to="/Dashboard" replace /> : <Login setLoggedIn={setLoggedIn} />} />
        <Route path="/Logout" element={<Logout setLoggedIn={setLoggedIn} />} />
        <Route path="/Dashboard/:firstTime" element={<HomeAnalytics />} />
        <Route path="/Dashboard" element={<HomeAnalytics />} />
        <Route path="/KnowledgeList" element={<KnowledgeList />} />
        <Route path="/KnowledgeInfo/:kbId?" element={<KnowledgeInfo />} />
        <Route path="/Agents" element={<Agents />} />
        <Route path="/Agent/:agentId?" element={<AgentDetail />} />
        <Route path="/Signup" element={<Signup />} />
        <Route path="/signup/form" element={<SignupForm setLoggedIn={setLoggedIn} />} />  {/* Add the new route */}
        <Route path="/AccountSettings" element={<AccountSettings />} />
        {/* New routes for Instructions */}
        <Route path="/InstructionsList" element={<InstructionsList />} />
        <Route path="/InstructionsInfo/:instructionId?" element={<InstructionsInfo />} />
        <Route path="/Instructions" element={<InstructionsList />} />
        {/* New routes for Dashboards */}
        <Route path="/tenant-dashboard" element={<TenantDashboard />} />
        <Route path="/usage-dashboard" element={<UsageDashboard />} />
        <Route path="/chat-main" element={<ChatMain />} />
        {/* System Alerts */}
        <Route path="/SystemAlerts" element={<SystemAlerts />} />
        {/* New routes for Forms */}
        <Route path="/FormsList" element={<FormsList />} />
        <Route path="/FormInfo/:formId?" element={<FormInfo />} />
        <Route path="/live-chat" element={<LiveChat />} />

        {/* Payment gate for paid plan signup */}
        <Route path="/complete-payment" element={<CompletePayment />} />
        {/* Setup routes */}
        <Route path="/agent-creation" element={<AgentCreation />} />
        {/* Analytics Dashboard */}
        <Route path="/analytics" element={<Analytics />} />
        {/* Routes for Chat Logs */}
        <Route path="/chat-logs" element={<ChatLogs />} />
        {/* Accept optional sessionId and any trailing tracking segments */}
        <Route path="/chat-logs/:sessionId/*" element={<ChatLogs />} />
        {/* Route for QA component */}
        <Route path="/qa" element={<QA />} />
        <Route path="/tools" element={<Tools />} />
      </Route>

      {/* Catch-all: redirect unknown paths to Dashboard, but do not override valid routes after login */}
      <Route path="*" element={<Navigate to="/Dashboard/true" replace />} />
    </Routes>
  );
}